module.exports = __webpack_public_path__ + "img/gold.d32c8515.png";